export default __webpack_public_path__ + "static/media/gallery-wip-handle_05.8d9e0808.jpg";